<template>
    <div id="chart-container" v-if="this.state.graph_mode == 'text'">
        <div id="chart-inner-container">
            <div class="anim-cont">
                <div class="nyan" :class="{'show': state.nyan}">
                    <img src="/bustabit/img/nyan.gif">
                </div>
            </div>
            <div class="max-profit">
                <strong><span>{{$trans('label.Max profit')}}: </span></strong>
                <span>{{utils.comma(this.state.max_profit)}}</span>
                <span>{{state.currency ? state.currency.toLowerCase() : ''}}</span>
            </div>
            <div id="text-display-container" :class="this.class_name" :style="{fontSize: parseInt(this.font_size) +'px', color: this.color}">
                <span v-if="this.state.game_state == 'IN_PROGRESS'">{{this.content.game_payout}}</span>
                <span class="busted" v-if="this.state.game_state == 'ENDED'">{{$trans('label.Busted')}}</span>
                <span class="at" v-if="this.state.game_state == 'ENDED'">{{this.content.at}}</span>
                <span v-if="this.state.game_state == 'STARTING'">{{this.content.time_left}}</span>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "text-display",
        props: ['state'],
        data: function() {
            return {
                utils: utils,
                class_name: null,
                size: {
                    in_progress: '60px',
                    ended: '60px',
                    starting: '60px'
                },
                font_size: '60px',
                color: '#7cba00',
                content: {
                    game_payout: null,
                    at: null,
                    time_left: null,
                },
            };
        },
        created() {
            EventBus.$on('connected', this.update);
            this._updateTimer = null;
        },
        beforeDestroy() {
            EventBus.$off('connected', this.update);
            if (this._updateTimer) {
                clearTimeout(this._updateTimer);
                this._updateTimer = null;
            }
            window.removeEventListener("resize", this.calcTextValues);
        },
        mounted() {
            EventBus.$emit('push_component', 'text-display');

            window.addEventListener("resize", this.calcTextValues);
            this.calcTextValues();
        },
        beforeUpdate() {
            // console.log('text-display before update');
        },
        updated() {
            // console.log('text-display updated');
        },
        methods: {
            update: function()
            {
                let self = this;
                self.render();

                self._updateTimer = setTimeout(function() {
                    self.update();
                }, 100);
            },
            render()
            {
                switch (this.state.game_state) {
                    case 'IN_PROGRESS':
                        this.class_name = 'in-progress';
                        if (StateLib.currentlyPlaying(this.state)) {
                            this.color = '#7cba00';
                        } else {
                            this.color = (this.state.theme === 'white'? "black" : "#b0b3c1");
                        }
                        this.font_size = this.size.in_progress;
                        this.content.game_payout = StateLib.getGamePayout(this.state).toFixed(2) + 'x';
                        break;
                    case 'ENDED':
                        this.class_name = 'ended';
                        this.color = 'red';
                        this.font_size = this.size.ended;
                        this.content.at = '@ ' + Clib.formatDecimals(this.state.game_history[0].game_crash / 100, 2) + 'x';
                        break;
                    case 'STARTING':
                        this.class_name = 'starting';
                        this.color = 'grey';
                        this.font_size = this.size.starting;
                        let time_left = ((this.state.start_time - Date.now()) / 1000).toFixed(1);
                        this.content.time_left = `${this.$trans('label.Next round in')} ${time_left}s`;
                        break;
                }
            },

            calcTextValues: function()
            {
                let chart_inner_container = $('#chart-inner-container')[0];
                let one_percent = chart_inner_container.clientWidth / 100;

                function fontSizePx(times) {
                    let font_size = one_percent * times;
                    return font_size.toFixed(2) + 'px';
                }

                this.size.in_progress = fontSizePx(20);
                this.size.ended = fontSizePx(10);
                this.size.starting = fontSizePx(4);
            },
        }
    }
</script>

<style scoped>

</style>
